import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Drawer, Flex } from '@mafc/trolly';

import { INewCartEntry } from 'pages/NewCart/ICart';

import ProductImage from '../ProductImage';

import * as S from './OOSItems.style';

export const Title = () => {
  const { t } = useTranslation();
  return (
    <Box
      fontWeight={[5, 6]}
      fontSize={[3, 4]}
      textAlign="center"
      sx={{
        fontFamily: 'Montserrat',
      }}
    >
      {t('outOfStock.itemsOutOfStock')}
    </Box>
  );
};

const OOSItems: React.FC<{
  isOpen: boolean;
  oosEntries: INewCartEntry[];
  close: () => void;
  removeItemsAndProceedCheckout: () => void;
}> = props => {
  const { isOpen, oosEntries, close, removeItemsAndProceedCheckout } = props;

  const { t } = useTranslation();
  const itemsCount = oosEntries.length;
  return (
    <Drawer
      onClose={close}
      isOpen={isOpen}
      width={[null, null, '500px']}
      anchor={['bottom', null, 'right']}
      contentStyles={{
        p: [0],
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Montserrat',
      }}
      variant="float"
      title={<Title />}
    >
      <S.OOSItems>
        <S.SubTitle>
          <Box>{t('outOfStock.sorryMessage1')}</Box>
          <S.TotalItems>
            {itemsCount} {itemsCount > 1 ? t('items.plural') : t('items.single')}
          </S.TotalItems>{' '}
          {t('outOfStock.sorryMessage2')}
        </S.SubTitle>

        {oosEntries.map(entry => {
          const { product } = entry;
          const { name, code } = product;

          return (
            <S.OOSEntryRow key={code}>
              <Flex alignItems="center">
                <ProductImage product={product} mr={'3'} outOfStock />
                <S.ProductName>{name}</S.ProductName>
              </Flex>
            </S.OOSEntryRow>
          );
        })}

        <S.RemoveAndCheckoutButton variant="primary" onClick={removeItemsAndProceedCheckout}>
          <>{t('outOfStock.proccedToCheckout')}</>
        </S.RemoveAndCheckoutButton>
      </S.OOSItems>
    </Drawer>
  );
};

export default OOSItems;
